import CRUDManager from './CRUDManager';

export default CRUDManager;
